export default __webpack_public_path__ + "static/media/i15.8e6fa1d3.png";